import React from 'react';

export const TITLE_OWNERSHIP_DISCLAIMER = 'Structural document continuity does not constitute verification of legal ownership or complete title history.';

export const formatOwnershipBranch = (branchId) => {
  if (!branchId || branchId === 'trunk') return 'Primary branch';
  return String(branchId).replace(/^TRUNK_/, '').replace(/_/g, ' ');
};

const displayStatus = (value, fallback = 'Not recorded') => String(value || fallback).replace(/_/g, ' ');

export const TitleContinuityQualification = ({ title, testIdPrefix }) => {
  if (!title) return null;
  const confidence = typeof title.confidence === 'number' ? `${Math.round(title.confidence * 100)}%` : 'Not recorded';
  const items = [
    ['Uploaded transfer sequence', displayStatus(title.uploaded_transfer_sequence_status || title.status), 'uploaded-sequence'],
    ['Structural/document confidence', confidence, 'structural-confidence'],
    ['Underlying title history', displayStatus(title.underlying_title_history_status), 'underlying-history'],
    ['Overall risk', displayStatus(title.risk_score), 'overall-risk'],
  ];
  return <section className="border border-amber-300 bg-amber-50 p-4" data-testid={`${testIdPrefix}-qualification`}>
    <h3 className="text-sm font-semibold text-amber-950" data-testid={`${testIdPrefix}-qualification-heading`}>Structural continuity qualification</h3>
    <dl className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {items.map(([label, value, suffix]) => <div key={suffix}>
        <dt className="text-xs font-semibold uppercase text-amber-800">{label}</dt>
        <dd className="mt-1 text-sm font-semibold text-amber-950" data-testid={`${testIdPrefix}-${suffix}`}>{value}</dd>
      </div>)}
    </dl>
    {title.confidence_label ? <p className="mt-3 text-xs font-semibold text-amber-900" data-testid={`${testIdPrefix}-confidence-scope`}>{displayStatus(title.confidence_label)}</p> : null}
    <p className="mt-3 text-sm text-amber-950" data-testid={`${testIdPrefix}-ownership-disclaimer`}>{TITLE_OWNERSHIP_DISCLAIMER}</p>
  </section>;
};